import script from "./ClipboardListTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./ClipboardListTable.vue?vue&type=script&setup=true&lang=ts"

import "./ClipboardListTable.vue?vue&type=style&index=0&id=39488d8a&lang=css"

const __exports__ = script;

export default __exports__